// extracted by mini-css-extract-plugin
export default {"oquesei":"Skills_oquesei__yhgJ3","container_skill":"Skills_container_skill__fAzhE","skills":"Skills_skills__n2t-S","skill-1":"Skills_skill-1__yPm2o"};